import styled from 'styled-components'

import type { ReactNode } from 'react'

type PageAreaProps = {
  children: ReactNode
  gridArea: 'header' | 'content' | 'navigation' | 'banner'
  style?: React.CSSProperties
}

const StyledPageArea = styled.div<{ $gridArea: string }>`
  grid-area: ${({ $gridArea }) => $gridArea};
  height: 100%;
  display: flex;
  flex-direction: column;
`

const PageArea = ({ children, gridArea, style }: PageAreaProps) => {
  return (
    <StyledPageArea $gridArea={gridArea} style={style}>
      {children}
    </StyledPageArea>
  )
}

export { PageArea }
